import React from "react";
import {Form} from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";


function WidgetDmbDtv({ options, iconCodeByBrcCode }) {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="방송수신 구분"
        fieldName={"dmb_dtv_code_list"}
        options={options.map(({ brc_knd, label }) => ({
          value: brc_knd,
          label,
          iconCode: iconCodeByBrcCode[brc_knd],
        }))}
        colSpan={12} />
    </Form.Item>
  );
}


export default WidgetDmbDtv;
